

<template>
  <v-container>

     <div style="border-style: solid; border-color: #2196F3">


           <div v-if="layer_index > -1">

<v-row>

            <v-col cols="12"  xs="12" sm="12" md="12">

                <v-row class="info_row" >
                                  <div>
                                     <v-list-item-title style="font-size: 24px" class="text-wrap">
                                      {{selectedLayer.text}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>(באלפים)</v-list-item-subtitle>
                                    <div v-if="selected_data.length > 0">
                                            
                                        <v-list-item-subtitle style="font-weight: bold;" v-if="selected_data"> {{selected_data[1]}} / {{selected_data[2]}}</v-list-item-subtitle>
                                            
                                        <v-avatar
                                        color="teal"
                                        size="70"
                                        >
                                        <span class="white--text text-h5">{{selected_data[4]}}</span>
                                        </v-avatar>

                                    </div>
                
                                    
                                    </div> 
                                     <v-spacer></v-spacer>

                     

                               <v-btn  @click="dialog = true"
                                class="mx-2"
                                fab
                                dark
                                small
                                color="primary"
                              >
                                <v-icon dark>
                                  mdi-help
                                </v-icon>
                              </v-btn>

                                </v-row>

                                <v-row class="info_row" > 
                                    
                                    <div v-if="selected_data.length > 0"> 
                                        <v-list-item-title style="font-size: 20px" class="text-wrap">
                                        צפיפות
                                        </v-list-item-title>
                                         <v-list-item-subtitle>צפיפות האוכלוסיה לקמ"ר יבשתי</v-list-item-subtitle>
                                        <v-avatar
                                         color="red"
                                        size="65"
                                        >
                                        <span class="white--text text-h6">{{selected_data[5]}}</span>
                                        </v-avatar>

                                    </div>
                                    
                                </v-row>


                                <v-row style="margin: 5px;"  v-if="selected_data[6] > 0"> 
                                    <div> 
                                        
                                        <v-list-item-title style="font-size: 20px" class="text-wrap">
                                        הגידול באוכלוסיה
                                        </v-list-item-title>
                                         <v-list-item-subtitle>לאורך השנים</v-list-item-subtitle>

                                    </div>

                                </v-row>

                                <v-row class="center info_row">
                                     <v-spacer></v-spacer> <bar-chart v-if="selected_data.length > 0" style="max-width:300px; max-height:250px" :cData="[selected_data[6],selected_data[7],selected_data[8]]"></bar-chart><v-spacer></v-spacer>
                                </v-row>

                               <!-- <v-row class="center" v-if="selected_data[6] > 0">
                                    <v-col cols="4" sm="4" xs="4">2005</v-col>
                                    <v-col cols="4" sm="4" xs="4">1967</v-col>
                                    <v-col cols="4" sm="4" xs="4">1948</v-col>
                                </v-row>
       
                                <v-sparkline v-if="selected_data[6] > 0"
                                    :gradient="['#FFF9C4', '#FFEE58','#FFEB3B','#BF360C']"
                                    type="bar"
                                    show-labels
                                    auto-line-width
                                    :value = [selected_data[6],selected_data[7],selected_data[8]]
                                ></v-sparkline> -->

             </v-col>
  
  
</v-row>

           
                              

              </div>
     </div>



       <v-dialog
      v-model="dialog"
      width="300"
    >
      <v-system-bar
      dark
      color="primary"
    >
      <v-spacer></v-spacer>
      <v-icon @click="dialog = false">mdi-close</v-icon>
    </v-system-bar>

                    <v-spacer></v-spacer>
                      <v-card center >
                    <v-img
                      :src="img" max-height="430" max-width="300"
                    >
                    
                    </v-img>
                    </v-card>
                    <v-spacer></v-spacer>
                              

    </v-dialog>

  </v-container>
</template>



<script>

import BarChart from '@/components/BarChart'
  export default {
    name: 'RegionDataDiv',
     components: {
        BarChart
    },

    data: () => ({

      dialog: false,
        

    }),
    computed:{
      layer_index(){
        return this.$store.state.layer_index;
      },
      selectedLayer(){
        return this.$store.state.selectedLayer;
      },
      selected_data(){
        return this.$store.state.selected_data_reg;
      },
      img(){
        return this.$store.state.img;
      }
    },
    //props: ['layer_index', 'selected_data'],



  }

</script>

<style scoped>
.info_row{
  background: #FFFFFF 0% 0% no-repeat padding-box;
                        box-shadow: 0px 2px 7px #00000014;
                        opacity: 1; margin: 5px;
}
</style>
